module.exports = __webpack_public_path__ + "resources/img/bg_cover_support_m.aeb23839deaae53aaa3b776f323f3aff.png";